import { ApplicationEntity } from "@graffer-inc/cloud-gov-core";
import { StatusTag } from "@graffer-inc/console-design-kit";
import * as React from "react";

export type SignatureStatusTagProps = {
  appl: ApplicationEntity;
};

export const SignatureStatusTag: React.FC<SignatureStatusTagProps> = ({
  appl,
}) => {
  return (
    <>
      {appl.hasSignature() &&
        appl.matchSignatureVerifyStatus({
          IS_INVALID: <StatusTag type={"DARK"}>無効</StatusTag>,
          IS_PENDING: <StatusTag type={"PRIMARY"}>検証中</StatusTag>,
          IS_VALID: <StatusTag type={"SUCCESS"}>有効性確認済み</StatusTag>,
        })}
    </>
  );
};
